import React from "react";
import { Box, Typography } from "@mui/material";
import logo from "@Assets/logo.png";

const Mobileview = () => {
  return (
    <Box
      height="100vh"
      width="100vw"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      textAlign="center"
      px={2}
      bgcolor="#f9f9f9"
    >
      {/* Logo */}
      <Box mb={3}>
        <img
          src={logo}
          alt="Logo"
          style={{
            width: "80px",
            height: "auto",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* Text Content */}
      <Box maxWidth="500px" width="100%">
        <Typography variant="h5" gutterBottom fontWeight="bold">
          📱 Mobile Access Not Supported
        </Typography>

        <Typography variant="body2" gutterBottom>
          🙏 Thank you for visiting MatWatch.
        </Typography>

        <Typography variant="body2" gutterBottom>
          🖥️ At this time, our website is optimized for desktop and larger-screen devices.
          For the best experience, please access this page from a laptop or desktop computer.
        </Typography>

        <Typography variant="body2">
          ⚠️ We apologize for any inconvenience and thank you for your understanding.
        </Typography>
      </Box>
    </Box>
  );
};

export default Mobileview;
